<template>
  <div class="p-lg">
    <h1 class="mb-xl">View Switcher List</h1>
    <div class="p-base mb-xl bg-signableBrandColours-white">
      <h3>View Switcher</h3>
      <ListOrCardViewSwitcher @setShowCardView="setShowCardView" />
      <p>Congratulations, your view is {{ view }}</p>
    </div>
    <div class="p-base bg-signableBrandColours-white mb-xl">
      <h3>Card View List</h3>
      <SelectableCardList
        :list="display"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="false"
      />
      <h3 class="mt-xl">Card View List - Loading</h3>
      <SelectableCardList
        :list="display"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="true"
      />
    </div>
    <div class="p-base bg-signableBrandColours-white mb-xl">
      <h3>List View List</h3>
      <SelectableList
        :list="display"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="false"
      />
      <h3 class="mt-xl">List View List - Loading</h3>
      <SelectableList
        :list="display"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="true"
      />
    </div>
    <div class="p-base bg-signableBrandColours-white mb-xl">
      <h3>Lists with Items with really long Strings to display - Card View List</h3>
      <SelectableCardList
        :list="longStringsDisplay"
        class="mb-xl"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="false"
      />
      <h3>Lists with Items with really long Strings to display - List View List</h3>
      <SelectableList
        :list="longStringsDisplay"
        ec="lists_design_page"
        itemType="thingamajig"
        @toggled="toggleSelected"
        :loading="false"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

import { SelectableCardList } from '@/components/library/lists/viewSwitcherList/SelectableCardList';
import { SelectableList } from '@/components/library/lists/viewSwitcherList/SelectableList';
import { ListOrCardViewSwitcher } from '@/components/library/viewSwitchers/ListOrCardViewSwitcher';

const selection = ref([]);
const showCard = ref(true);
const list = ref([
  {
    title: 'Rich',
    id: 'one',
    secondaryInfo: 'Edam',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'Aled',
    id: 'two',
    secondaryInfo: 'Cheese',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'Max',
    id: 'three',
    secondaryInfo: 'Mozzarella',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'Laurence',
    id: 'four',
    secondaryInfo: 'Babybel',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'Laura',
    id: 'five',
    secondaryInfo: 'Stilton',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
]);
const longStringsList = ref([
  {
    title: 'MyNameIsSoLongICannotEvenRememberIt',
    id: 'longStringsOne',
    secondaryInfo: 'VeryLongInfo',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'MyNameIsEvenLonger ButItDoesAtLeastHaveASpaceInTheMiddleOfIt',
    id: 'longStringsTwo',
    secondaryInfo: 'EvenLongerInfo',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
  {
    title: 'MyNameIsINCREDIBLYLongAndThereAreNoSpacesButThereIsPunctuation.MyLifeIsInShamblesBecauseOfMyStupidlyLongName.ButYouCanCallMeSteve.',
    id: 'longStringsThree',
    secondaryInfo: 'INFO INFO INFO INFO INFO INFO INFO INFO INFO INFO INFO',
    thumbnail: 'https://en.wikipedia.org/wiki/Smiley#/media/File:SNice.svg',
  },
]);

function setShowCardView(setting) {
  showCard.value = setting;
}

function toggleSelected(id, title) {
  const index = selection.value.findIndex(item => item.id === id);
  if (index > -1) {
    selection.value.splice(index, 1);
  } else {
    selection.value.push({ id, title });
  }
}

const view = computed(() => (showCard.value ? 'card' : 'list'));

const display = computed(() => list.value.map(item => ({
  title: item.title,
  id: item.id,
  secondaryInfo: item.secondaryInfo,
  thumbnail: item.thumbnail,
  selected: selection.value.some(selectedItem => item.id === selectedItem.id),
})));
const longStringsDisplay = computed(() => longStringsList.value.map(item => ({
  title: item.title,
  id: item.id,
  secondaryInfo: item.secondaryInfo,
  thumbnail: item.thumbnail,
  selected: selection.value.some(selectedItem => item.id === selectedItem.id),
})));
</script>
